

// import { useState, useEffect } from "react";
// import { useSearchParams } from "react-router-dom";

// const BASE_URL = process.env.REACT_APP_QUANTUMURL;

// // ── Helpers ──────────────────────────────────────────────────────────────────

// function formatName(name) {
//   return name.replace(/\.[^.]+$/, "").replace(/_/g, " ");
// }

// function formatSize(bytes) {
//   if (bytes > 1048576) return (bytes / 1048576).toFixed(1) + " MB";
//   return Math.round(bytes / 1024) + " KB";
// }

// function formatDate(iso) {
//   return new Date(iso).toLocaleDateString("en-IN", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//   });
// }

// // FIX: Use /download suffix to get the actual signed GCS URL
// function getDocUrl(doc) {
//   if (doc.gcs_path) {
//     return doc.gcs_path.replace(
//       "gs://",
//       "https://storage.googleapis.com/"
//     );
//   }
//   return "#";
// }

// async function fetchDocuments(category) {
//   const res = await fetch(`${BASE_URL}/documents?category=${category}`, {
//     headers: { accept: "application/json" },
//   });
//   if (!res.ok) throw new Error(`HTTP ${res.status}`);
//   return res.json();
// }

// // ── Colour palettes ───────────────────────────────────────────────────────────

// const REPORT_COLORS = [
//   { bg: "#EDE9FE", icon: "#7C3AED", border: "#C4B5FD" },
//   { bg: "#DCFCE7", icon: "#16A34A", border: "#86EFAC" },
//   { bg: "#FEF3C7", icon: "#D97706", border: "#FCD34D" },
//   { bg: "#DBEAFE", icon: "#2563EB", border: "#93C5FD" },
//   { bg: "#FCE7F3", icon: "#DB2777", border: "#F9A8D4" },
//   { bg: "#CCFBF1", icon: "#0D9488", border: "#5EEAD4" },
// ];

// const PAPER_COLORS = [
//   { bg: "#EDE9FE", icon: "#7C3AED", border: "#C4B5FD" },
//   { bg: "#CCFBF1", icon: "#0D9488", border: "#5EEAD4" },
//   { bg: "#FEF3C7", icon: "#D97706", border: "#FCD34D" },
// ];

// // ── Spinner ───────────────────────────────────────────────────────────────────

// function Spinner({ color = "#7C3AED" }) {
//   return (
//     <div className="flex items-center gap-3 py-10 px-4 text-gray-400 text-sm">
//       <svg className="animate-spin w-5 h-5" style={{ color }} viewBox="0 0 24 24" fill="none">
//         <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeDasharray="60" strokeDashoffset="20" />
//       </svg>
//       Loading…
//     </div>
//   );
// }

// // ── Validation Reports ────────────────────────────────────────────────────────

// function ValidationReports() {
//   const [docs, setDocs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchDocuments("reports")
//       .then((data) => setDocs(data.documents || []))
//       .catch((e) => setError(e.message))
//       .finally(() => setLoading(false));
//   }, []);

//   if (loading) return <Spinner color="#7C3AED" />;
//   if (error) return <p className="text-gray-400 text-sm py-8 px-4">Error: {error}</p>;
//   if (!docs.length) return <p className="text-gray-400 text-sm py-8 px-4">No reports found.</p>;

//   return (
//     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 px-4 md:px-8 py-6">
//       {docs.map((doc, i) => {
//         const c = REPORT_COLORS[i % REPORT_COLORS.length];
//         return (
//           <a
//             key={doc.id}
//             href={getDocUrl(doc)}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="group flex flex-col rounded-2xl border bg-white transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 no-underline overflow-hidden"
//             style={{ borderColor: c.border }}
//           >
//             {/* Coloured top band */}
//             <div className="flex items-center gap-3 px-5 py-4" style={{ backgroundColor: c.bg }}>
//               <div
//                 className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
//                 style={{ backgroundColor: c.icon + "22", border: `1.5px solid ${c.border}` }}
//               >
//                 <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
//                   <rect x="4" y="2" width="11" height="15" rx="2" fill={c.icon} opacity="0.3" />
//                   <rect x="9" y="2" width="6" height="5" rx="1" fill={c.icon} opacity="0.7" />
//                   <rect x="4" y="13" width="16" height="9" rx="2" fill={c.icon} />
//                   <text x="12" y="20.5" textAnchor="middle" fill="white" fontSize="4" fontWeight="700" fontFamily="sans-serif">PDF</text>
//                 </svg>
//               </div>
//               <p className="flex-1 text-sm font-semibold capitalize leading-snug" style={{ color: c.icon }}>
//                 {formatName(doc.name)}
//               </p>
//               <svg
//                 className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0"
//                 style={{ color: c.icon }}
//                 viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
//               >
//                 <path d="M7 17L17 7M17 7H7M17 7V17" />
//               </svg>
//             </div>

//             {/* Meta */}
//             <div className="flex items-center justify-between px-5 py-3">
             
//             </div>
//           </a>
//         );
//       })}
//     </div>
//   );
// }

// // ── Research Publications ─────────────────────────────────────────────────────

// function ResearchPublications() {
//   const [docs, setDocs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchDocuments("papers")
//       .then((data) => setDocs(data.documents || []))
//       .catch((e) => setError(e.message))
//       .finally(() => setLoading(false));
//   }, []);

//   if (loading) return <Spinner color="#0D9488" />;
//   if (error) return <p className="text-gray-400 text-sm py-8 px-4">Error: {error}</p>;
//   if (!docs.length) return <p className="text-gray-400 text-sm py-8 px-4">No publications found.</p>;

//   return (
//     <div className="flex flex-col gap-5 px-4 md:px-8 py-6">
//       {docs.map((doc, i) => {
//         const c = PAPER_COLORS[i % PAPER_COLORS.length];
//         return (
//           <a
//             key={doc.id}
//             href={getDocUrl(doc)}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="group flex items-center gap-0 rounded-2xl border bg-white transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 no-underline overflow-hidden"
//             style={{ borderColor: c.border }}
//           >
//             {/* Left colour strip */}
//             <div
//               className="flex items-center justify-center w-20 self-stretch flex-shrink-0"
//               style={{ backgroundColor: c.bg }}
//             >
//               <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
//                 <rect x="3" y="2" width="13" height="17" rx="2" fill={c.icon} opacity="0.25" />
//                 <rect x="9" y="2" width="7" height="6" rx="1" fill={c.icon} opacity="0.7" />
//                 <rect x="3" y="15" width="18" height="7" rx="2" fill={c.icon} />
//                 <line x1="6" y1="10" x2="13" y2="10" stroke={c.icon} strokeWidth="1.2" strokeLinecap="round" />
//                 <line x1="6" y1="13" x2="11" y2="13" stroke={c.icon} strokeWidth="1.2" strokeLinecap="round" />
//               </svg>
//             </div>

//             {/* Content */}
//             <div className="flex-1 min-w-0 py-5 px-5">
//               <p className="text-sm font-semibold text-gray-800 leading-snug mb-2">
//                 {formatName(doc.name)}
//               </p>
//               <div className="flex items-center gap-3 flex-wrap">
//                 <span
//                   className="text-xs font-semibold px-3 py-1 rounded-full"
//                   style={{ backgroundColor: c.bg, color: c.icon }}
//                 >
//                   Research Paper
//                 </span>
               
//               </div>
//             </div>

//             {/* Arrow */}
//             <div className="pr-5 flex-shrink-0">
//               <svg
//                 className="w-5 h-5 text-gray-300 group-hover:text-gray-500 transition-colors"
//                 viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
//               >
//                 <path d="M7 17L17 7M17 7H7M17 7V17" />
//               </svg>
//             </div>
//           </a>
//         );
//       })}
//     </div>
//   );
// }

// // ── Main Exported Component ───────────────────────────────────────────────────

// export default function DocumentsSection() {
//   const [searchParams] = useSearchParams();
//   const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "reports");

//   // 🔥 keep in sync with URL when header navigation changes
//   useEffect(() => {
//     const tabFromUrl = searchParams.get("tab") || "reports";
//     setActiveTab(tabFromUrl);
//   }, [searchParams]);

//   return (
//     <div className="min-h-[calc(100vh-58px)] bg-gray-50">
//       <div className="max-w-5xl mx-auto pt-6 pb-16">

//         {/* ❌ Tabs removed */}

//         {activeTab === "reports" && <ValidationReports />}
//         {activeTab === "papers" && <ResearchPublications />}

//       </div>
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_QUANTUMURL;
const CMS_BASE_URL = process.env.REACT_APP_CMS_BASEURL;

// ── Helpers ───────────────────────────────────────────────────────────────────

// CMS icon fields may hold either an image URL or a plain emoji/character —
// render each the right way instead of assuming it's always a loadable image.
function isImageUrl(value) {
  return typeof value === "string" && /^https?:\/\//i.test(value.trim());
}

function CmsIcon({ value, size = 40 }) {
  if (!value) return null;
  if (isImageUrl(value)) {
    return <img src={value} alt="" style={{ width: size, height: size, objectFit: "contain" }} />;
  }
  return (
    <span style={{ fontSize: size * 0.8, lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
      {value}
    </span>
  );
}

function formatName(name) {
  return name.replace(/\.[^.]+$/, "").replace(/_/g, " ");
}

function getDocUrl(doc) {
  if (doc.gcs_path) {
    return doc.gcs_path.replace("gs://", "https://storage.googleapis.com/");
  }
  return "#";
}

async function fetchDocuments(category) {
  const res = await fetch(`${BASE_URL}/documents?category=${category}`, {
    headers: { accept: "application/json" },
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

async function fetchCMSData() {
  const res = await axios.get(
    `${CMS_BASE_URL}quantum-mains?populate=reports,reports.validation,reports.research`
  );
  return res.data;
}

// ── Colour palettes ───────────────────────────────────────────────────────────

const REPORT_COLORS = [
  { bg: "#EAF3FA", icon: "#004276", border: "#C9EEF8" },
  { bg: "#DBEAFE", icon: "#2563EB", border: "#93C5FD" },
  { bg: "#FCE7F3", icon: "#DB2777", border: "#F9A8D4" },
  { bg: "#DCFCE7", icon: "#16A34A", border: "#86EFAC" },
  { bg: "#FEF3C7", icon: "#D97706", border: "#FCD34D" },
  { bg: "#CCFBF1", icon: "#0D9488", border: "#5EEAD4" },
];

const PAPER_COLORS = [
  { bg: "#EAF3FA", icon: "#004276", border: "#C9EEF8" },
  { bg: "#CCFBF1", icon: "#0D9488", border: "#5EEAD4" },
  { bg: "#FEF3C7", icon: "#D97706", border: "#FCD34D" },
];

// ── Spinner ───────────────────────────────────────────────────────────────────

function Spinner({ color = "#004276" }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "40px 32px", color: "#9CA3AF", fontSize: 14 }}>
      <svg
        style={{ width: 20, height: 20, color, animation: "spin 1s linear infinite" }}
        viewBox="0 0 24 24"
        fill="none"
      >
        <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeDasharray="60" strokeDashoffset="20" />
      </svg>
      Loading…
    </div>
  );
}

// ── Gradient Text style ───────────────────────────────────────────────────────

const gradientTextStyle = {
  color: "var(--color-brand-primary)",
};

// ── Hero Banner (shared) ──────────────────────────────────────────────────────

function HeroBanner({ cms, isResearch }) {
  return (
    <div
      className="qdoc-hero"
      style={{
        width: "100%",
        background: "var(--section-bg-gradient), #fff",
        padding: "18px 64px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: 220,
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Left content */}
      <div className="qdoc-hero-left" style={{ flex: 1, maxWidth: 650 }}>
        {/* Badge */}
        <div
  style={{
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "rgba(255,255,255,0.7)",
    border: "0.5px solid rgba(255,255,255,0.9)",
    borderRadius: 20,
    padding: "4px 14px",
    marginBottom: 16
  }}
>
  <span
    style={{
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: "var(--color-brand-primary)",
      display: "inline-block"
    }}
  />

  <span
    style={{
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: 12,
      lineHeight: "100%",
      letterSpacing: "0%",
      color: "var(--color-brand-primary)"
    }}
  >
    {cms?.description1 ||
      (isResearch
        ? "Peer-Reviewed Science"
        : "AI-Validated · Clinically Reviewed")}
  </span>
</div>

        <h1
  style={{
    fontFamily: "Inter, sans-serif",
    fontSize: 36,
    fontWeight: 700,
    lineHeight: "43.2px",
    letterSpacing: "-0.5px",
    marginBottom: 8,
    ...gradientTextStyle
  }}
>
          {cms?.heading || (isResearch ? "Research Publications" : "Validation Reports")}
        </h1>

       <p
  style={{
    fontFamily: "Inter, sans-serif",
    fontSize: 24,
    fontWeight: 600,
    lineHeight: "100%",
    letterSpacing: "0%",
    color: "var(--color-text-subheading)",
    marginBottom: 10
  }}
>
          {cms?.subheading || (isResearch
            ? "Advancing Healthcare Through Evidence and Innovation"
            : "Transparency you can trust. Results you can rely on.")}
        </p>

        <p
  style={{
    fontFamily: "Inter, sans-serif",
    fontSize: 15,
    fontWeight: 400,
    lineHeight: "25.5px",
    letterSpacing: "0%",
    color: "#0C0C0C",
    marginBottom: 20
  }}
>
  {cms?.description || ""}
</p>
        
      </div>

      {/* Hero image from CMS */}
      {cms?.imgurl && (
        <div className="qdoc-hero-img-wrap" style={{ flexShrink: 0, marginLeft: 18 }}>
          <img
  src={cms.imgurl}
  alt={isResearch ? "Research Publications" : "Validation Reports"}
  style={{
    width: 476,
    height: 300,
    objectFit: "contain",
    display: "block"
  }}
/>
        </div>
      )}
    </div>
  );
}

// ── Validation Reports ────────────────────────────────────────────────────────

function ValidationReports({ cms, docs, loading, error }) {

  const cmsIcons = cms?.validation || [];

  return (
    <div style={{ minHeight: "100vh", background: "#F9FAFB" }}>
      <HeroBanner cms={cms} isResearch={false} />

      {/* Section heading */}
      <div className="qdoc-section-head" style={{ padding: "40px 64px 20px" }}>
        <h2
  style={{
    fontFamily: "Inter, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    lineHeight: "40px",
    letterSpacing: "0.3%",
    marginBottom: 6,

    color: "var(--color-brand-primary)"
  }}
>
  {cms?.heading2 || "Validation Categories"}
</h2>
        <p
  style={{
    fontFamily: "Inter, sans-serif",
    fontSize: 18,
    fontWeight: 400,
    lineHeight: "28px",
    letterSpacing: "0.3%",
    color: "var(--color-text-subheading)",
    margin: 0
  }}
>
  {cms?.subheading2 ||
    "Explore detailed validation reports across all AI-powered diagnostic models"}
</p>
      </div>

      {/* Cards grid */}
      {loading ? (
        <Spinner color="#004276" />
      ) : error ? (
        <p style={{ color: "#9CA3AF", fontSize: 14, padding: "32px 64px" }}>Error: {error}</p>
      ) : !docs.length ? (
        <p style={{ color: "#9CA3AF", fontSize: 14, padding: "32px 64px" }}>No reports found.</p>
      ) : (
        <div
          className="qdoc-cards-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: 20,
            padding: "0 64px 64px",
          }}
        >
          {docs.map((doc, i) => {
            const c = REPORT_COLORS[i % REPORT_COLORS.length];
            const iconUrl = cmsIcons[i]?.iconurl || null;
            return (
              <a
                key={doc.id}
                href={getDocUrl(doc)}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 18,
                  border: `1px solid ${c.border}50`,
                  background: "#fff",
                  textDecoration: "none",
                  overflow: "hidden",
                  transition: "transform 0.18s ease, box-shadow 0.18s ease",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 8px 28px rgba(128,218,241,0.35)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.05)";
                }}
              >
                {/* Coloured top section */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    padding: "20px 20px 16px",
                    background: "#FFFFFF",
                  }}
                >
                  <div
                    style={{
                      width: 64,
                      height: 64,
                      borderRadius: 13,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      background: "transparent",
border: "none",
                    }}
                  >
                    {iconUrl ? (
                      <CmsIcon value={iconUrl} size={40} />
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="4" y="2" width="11" height="15" rx="2" fill={c.icon} opacity="0.3" />
                        <rect x="9" y="2" width="6" height="5" rx="1" fill={c.icon} opacity="0.7" />
                        <rect x="4" y="13" width="16" height="9" rx="2" fill={c.icon} />
                        <text x="12" y="20.5" textAnchor="middle" fill="white" fontSize="4" fontWeight="700" fontFamily="sans-serif">PDF</text>
                      </svg>
                    )}
                  </div>
                  <div
  style={{
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }}
>
                    <p
  style={{
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.35,
    textTransform: "capitalize",
    margin: "0 0 6px",

    color: "var(--color-brand-primary)"
  }}
>
                      {formatName(doc.name)}
                    </p>
                    {doc.description && (
                      <p style={{ fontSize: 12, color: "#6B7280", lineHeight: 1.5, margin: 0 }}>
                        {doc.description}
                      </p>
                    )}
                  </div>
                  
                </div>

                {/* Footer meta */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "13px 20px",
                    background: "linear-gradient(282.08deg, #DFF1FB 2.51%, #FFFFFF 100.3%)",
                  }}
                >
                  <span style={{ fontSize: 12, color: "#6B7280" }}>
                    {doc.count != null
                      ? `${doc.count} Validation Reports`
                      : doc.size
                        ? doc.size > 1048576
                          ? (doc.size / 1048576).toFixed(1) + " MB"
                          : Math.round(doc.size / 1024) + " KB"
                        : "PDF"}
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      ...gradientTextStyle,
                    }}
                  >
                    View Reports
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#004276" strokeWidth="2.5">
                      <path d="M7 17L17 7M17 7H7M17 7V17" />
                    </svg>
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      )}

      <p className="qdoc-footer-note" style={{ textAlign: "center", fontSize: 12, color: "#9CA3AF", padding: "0 64px 48px", borderTop: "0.5px solid #F3F4F6", paddingTop: 28 }}>
        All reports are generated using real-world data and validated by clinical experts.
      </p>
    </div>
  );
}

// ── Research Publications ─────────────────────────────────────────────────────

function ResearchPublications({ cms, docs, loading, error }) {

  const cmsIcons = cms?.research || [];

  return (
    <div style={{ minHeight: "100vh", background: "#F9FAFB" }}>
      <HeroBanner cms={cms} isResearch={true} />

      {/* Section heading */}
      <div className="qdoc-section-head" style={{ padding: "40px 64px 20px" }}>
        <h2
  style={{
    fontFamily: "Inter, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    lineHeight: "40px",
    letterSpacing: "0.3%",
    marginBottom: 6,

    color: "var(--color-brand-primary)"
  }}
>
          {cms?.heading2 || "Recent Publications"}
        </h2>
         <p
  style={{
    fontFamily: "Inter, sans-serif",
    fontSize: 18,
    fontWeight: 400,
    lineHeight: "28px",
    letterSpacing: "0.3%",
    color: "var(--color-text-subheading)",
    margin: 0
  }}
>
          {cms?.subheading2 || "Explore detailed researches done to achieve our AI-powered diagnostic models successfully"}
        </p>
      </div>

      {/* Publication rows */}
      {loading ? (
        <Spinner color="#004276" />
      ) : error ? (
        <p style={{ color: "#9CA3AF", fontSize: 14, padding: "32px 64px" }}>Error: {error}</p>
      ) : !docs.length ? (
        <p style={{ color: "#9CA3AF", fontSize: 14, padding: "32px 64px" }}>No publications found.</p>
      ) : (
        <div className="qdoc-pub-list" style={{ display: "flex", flexDirection: "column", gap: 14, padding: "0 64px 64px" }}>
          {docs.map((doc, i) => {
            const c = PAPER_COLORS[i % PAPER_COLORS.length];
            const iconUrl = cmsIcons[i]?.iconurl || null;
            const isOpenAccess = doc.access_type === "open" || i % 2 === 0;
            return (
              <a
                key={doc.id}
                href={getDocUrl(doc)}
                target="_blank"
                rel="noopener noreferrer"
                className="qdoc-pub-row"
                style={{
                  display: "flex",
                  alignItems: "stretch",
                  borderRadius: 18,
                  border: "1px solid #E5E7EB",
                  background: "#fff",
                  textDecoration: "none",
                  overflow: "hidden",
                  transition: "transform 0.18s ease, box-shadow 0.18s ease",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 6px 24px rgba(128,218,241,0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.04)";
                }}
              >
                {/* Left icon strip */}
                <div
                  className="qdoc-pub-icon"
                  style={{
                    width: 80,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    background: "linear-gradient(282.08deg, #DFF1FB 2.51%, #FFFFFF 100.3%)",
                  }}
                >
                  {iconUrl ? (
                    <CmsIcon value={iconUrl} size={40} />
                  ) : (
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="2" width="13" height="17" rx="2" fill={c.icon} opacity="0.25" />
                      <rect x="9" y="2" width="7" height="6" rx="1" fill={c.icon} opacity="0.7" />
                      <rect x="3" y="15" width="18" height="7" rx="2" fill={c.icon} />
                      <line x1="6" y1="10" x2="13" y2="10" stroke={c.icon} strokeWidth="1.2" strokeLinecap="round" />
                      <line x1="6" y1="13" x2="11" y2="13" stroke={c.icon} strokeWidth="1.2" strokeLinecap="round" />
                    </svg>
                  )}
                </div>

                {/* Main content */}
                <div className="qdoc-pub-content" style={{ flex: 1, minWidth: 0, padding: "18px 24px" }}>
                  <p style={{ fontSize: 14, fontWeight: 700, color: "#1F2937", lineHeight: 1.45, marginBottom: 8 }}>
                    {formatName(doc.name)}
                  </p>

                  {/* Authors */}
                  {doc.authors && (
                    <p style={{ fontSize: 12, color: "#6B7280", marginBottom: 8 }}>{doc.authors}</p>
                  )}

                  {/* Meta row */}
                  <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                    {doc.journal && (
                      <span style={{ fontSize: 12, fontWeight: 700, color: "#374151" }}>{doc.journal}</span>
                    )}
                    {doc.volume && (
                      <span style={{ fontSize: 12, color: "#9CA3AF" }}>{doc.volume}</span>
                    )}
                    {doc.date && (
                      <span style={{ fontSize: 12, color: "#9CA3AF" }}>{doc.date}</span>
                    )}
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        padding: "3px 10px",
                        borderRadius: 20,
                        background: "linear-gradient(282.08deg, #DFF1FB 2.51%, #FFFFFF 100.3%)",
                        color: "var(--color-brand-primary)",
                      }}
                    >
                      {doc.type || "Research Paper"}
                    </span>
                  </div>
                </div>

                {/* Right: badge + arrow */}
                <div className="qdoc-pub-right" style={{ padding: "18px 24px", display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "space-between", flexShrink: 0 }}>
                  
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      ...gradientTextStyle,
                    }}
                  >
                    View Publication
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#004276" strokeWidth="2.5">
                      <path d="M7 17L17 7M17 7H7M17 7V17" />
                    </svg>
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      )}

      <p className="qdoc-footer-note" style={{ textAlign: "center", fontSize: 12, color: "#9CA3AF", maxWidth: 560, margin: "0 auto", padding: "0 64px 48px", borderTop: "0.5px solid #F3F4F6", paddingTop: 28 }}>
        Publications are selected based on relevance, impact, and scientific contribution to healthcare innovation.
        All listed works have been independently verified and are linked to their original journal sources.
      </p>
    </div>
  );
}

// ── Main Exported Component ───────────────────────────────────────────────────

export default function DocumentsSection() {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "reports");
  const [cmsData, setCmsData] = useState({ reports: null, papers: null });
  const [reportDocs, setReportDocs] = useState([]);
  const [paperDocs, setPaperDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const tabFromUrl = searchParams.get("tab") || "reports";
    setActiveTab(tabFromUrl);
  }, [searchParams]);

  useEffect(() => {
    // Load CMS data + documents simultaneously so icons are ready when cards render
    Promise.all([
      fetchCMSData(),
      fetchDocuments("reports"),
      fetchDocuments("papers"),
    ])
      .then(([cmsRes, reportsRes, papersRes]) => {
        const reports = cmsRes?.data?.[0]?.attributes?.reports || [];
        // Match each CMS "reports" entry by what it actually contains, not by
        // array position — the CMS doesn't guarantee a stable order, and a
        // reorder there previously caused the Validation section to pick up
        // the Research entry's (empty) validation icon list, and vice versa.
        const findSection = (list, kind) =>
          list.find((r) => Array.isArray(r?.[kind]) && r[kind].length > 0) ||
          list.find((r) =>
            kind === "validation"
              ? /validation/i.test(r?.heading || "")
              : /research|publication/i.test(r?.heading || "")
          ) ||
          null;
        setCmsData({
          reports: findSection(reports, "validation") || reports[0] || null,
          papers: findSection(reports, "research") || reports[1] || null,
        });
        setReportDocs(reportsRes.documents || []);
        setPaperDocs(papersRes.documents || []);
      })
      .catch((err) => {
        console.error("Data fetch error:", err);
        setError(err.message);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <style>{`
        @media (max-width: 640px) {
          .qdoc-hero { flex-direction: column !important; align-items: flex-start !important; padding: 24px 20px !important; min-height: auto !important; }
          .qdoc-hero-left { max-width: 100% !important; }
          .qdoc-hero-img-wrap { margin-left: 0 !important; margin-top: 16px !important; width: 100% !important; display: flex !important; justify-content: center !important; }
          .qdoc-hero-img-wrap img { width: 100% !important; height: auto !important; }
          .qdoc-section-head { padding: 24px 20px 12px !important; }
          .qdoc-section-head h2 { font-size: 22px !important; line-height: 28px !important; }
          .qdoc-section-head p { font-size: 14px !important; line-height: 20px !important; }
          .qdoc-cards-grid { padding: 0 16px 32px !important; grid-template-columns: 1fr !important; }
          .qdoc-pub-list { padding: 0 16px 32px !important; }
          .qdoc-pub-row { flex-direction: column !important; }
          .qdoc-pub-icon { width: 100% !important; padding: 14px 0 !important; }
          .qdoc-pub-content { padding: 14px 16px !important; }
          .qdoc-pub-right { flex-direction: row !important; align-items: center !important; justify-content: flex-start !important; padding: 12px 16px 16px !important; }
          .qdoc-footer-note { padding: 0 16px 32px !important; }
        }
      `}</style>
      {activeTab === "reports" && (
        <ValidationReports
          cms={cmsData.reports}
          docs={reportDocs}
          loading={loading}
          error={error}
        />
      )}
      {activeTab === "papers" && (
        <ResearchPublications
          cms={cmsData.papers}
          docs={paperDocs}
          loading={loading}
          error={error}
        />
      )}
    </>
  );
}